import jwtDecode from 'jwt-decode';

// const BASE_URL = window.configuration.baseUrl;
const AWS_URL = window.configuration.awsUrl;
const REFRESH_URL = window.configuration.refreshUrl;
const SP_CLIENT_ID= window.configuration.sp_clientId;

export function getToken() {
  return new Promise((resolve, reject) => {
    let token = sessionStorage.getItem('spasts_token');
    //remove token if it exists and it is expired
    if ((token !== null) && token !== "undefined") {
      const decoded = jwtDecode(sessionStorage.getItem('spasts_token'));
      // if token is expired ask new
      let refreshToken = sessionStorage.getItem('refresh_token');
      if (refreshToken === null) {
        sessionStorage.removeItem('spasts_token');
        reject({'error': "no token found"});
      } 
      if (decoded.exp < Math.floor(Date.now() / 1000) && refreshToken != null) {
        var body = `grant_type=refresh_token&client_id=${SP_CLIENT_ID}&refresh_token=${refreshToken}`;
          fetch(`${REFRESH_URL}`, {
                headers: new Headers({
                    'Content-Type': 'application/x-www-form-urlencoded'
                }),
                method: 'post',
                body: body,
              }).then(response => {
                if (response.status === 401) {
                    this.context.router.push('/');
                    reject({'error': "not authorized"});
                }   
                return response.json()
              }).then(tokens => {
                sessionStorage.removeItem('spasts_token');  
                sessionStorage.setItem('spasts_token', tokens.id_token); 
                resolve (tokens.id_token);
          });
      } else {
        resolve (token);
      }
    } else { 
      reject({'error': "no token"});
    }
  });
}



// WEBPACK FOOTER //
// ./src/services/getToken.js